import { axiosInstanceCMS } from "./AxiosInstance";
import { axiosInstancejob } from "./AxiosInstance";

const API_URL_MAIL = "/api/mail/apply";
const API_URL_APPLICATION = "/jobappliedstudents"; // Using relative path for axiosInstanceCMS

// Service function for sending mail
export const sendJobApplicationMail = async (applicationData) => {
  try {
    const formData = new FormData();

    // Append all form fields
    Object.keys(applicationData).forEach((key) => {
      if (key !== "cvUpload" && applicationData[key]) {
        formData.append(key, applicationData[key]);
      }
    });

    // Append CV file
    if (applicationData.cvUpload) {
      formData.append("cvUpload", applicationData.cvUpload);
    }

    // Using direct axios for mail service (keeping your original logic)
    const response = await axiosInstanceCMS.post("" + API_URL_MAIL, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error sending job application mail:", error);
    throw error;
  }
};

// Service function for posting job application data
export const submitJobApplicationData = async (applicationData, jobId) => {
  try {
    const formData = new FormData();

    // IMPORTANT: Append job ID first
    if (jobId) {
     
    } else {
      console.error("Service: No jobId provided");
      throw new Error("Job ID is required for application submission");
    }

    // Append all form fields
    Object.keys(applicationData).forEach((key) => {
      if (key !== "cvUpload" && applicationData[key]) {
        formData.append(key, applicationData[key]);
        
      }
    });

    // Append CV file
    if (applicationData.cvUpload) {
      formData.append("cvUpload", applicationData.cvUpload);
  
    }

    // Log all FormData entries

    // for (let [key, value] of formData.entries()) {
    //   console.log(key, value);
    // }

    const response = await axiosInstancejob.post(API_URL_APPLICATION, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error submitting job application data:", error);
    throw error;
  }
};

// NEW SERVICE FUNCTION: Get all job applications
export const getJobApplications = async (page = 1, limit = 100) => {
  try {
    const response = await axiosInstancejob.get(`${API_URL_APPLICATION}?page=${page}&limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching job applications:", error);
    throw error;
  }
};
